var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var _excluded = ["layout", "intl", "initialValue", "tag", "customItemRenderer", "label", "extra", "help", "validateStatus", "placeholder", "form", "formItemClassName", "rules", "isFormItem"], _excluded2 = ["name"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
import React from "react";
import { tagToRenderer } from "./renderers";
import { FormItem as AntDFormItem } from "../item/Item";
import { translateFormMessages } from "../utils/helpers";
function FormItemRenderer(props) {
  var layout = props.layout, intl = props.intl, _props$initialValue = props.initialValue, initialValue = _props$initialValue === void 0 ? null : _props$initialValue, tag = props.tag, customItemRenderer = props.customItemRenderer, label = props.label, extra = props.extra, help = props.help, validateStatus = props.validateStatus, placeholder = props.placeholder, form = props.form, formItemClassName = props.formItemClassName, rulesList = props.rules, _props$isFormItem = props.isFormItem, isFormItem = _props$isFormItem === void 0 ? true : _props$isFormItem, fieldSettings = _objectWithoutProperties(props, _excluded);
  var isInline = layout === "inline";
  var isRequired = rulesList && Array.isArray(rulesList) && rulesList.filter(function(i) {
    return i.required === true;
  }).length > 0;
  var formItemTranslatedProps = [{
    attribute: "label",
    value: isInline ? null : label
  }, {
    attribute: "extra",
    value: extra
  }, {
    attribute: "help",
    value: help
  }].filter(function(_ref) {
    var value = _ref.value;
    return !!value;
  }).reduce(function(result, _ref2) {
    var attribute = _ref2.attribute, value = _ref2.value;
    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, attribute, intl.formatMessage({
      id: value
    })));
  }, {
    isRequired
  });
  var formItemProps = _objectSpread(_objectSpread({}, formItemTranslatedProps), {}, {
    validateStatus,
    className: formItemClassName,
    hidden: fieldSettings.type === "hidden"
  });
  var placeholderValue = placeholder || isInline && label ? placeholder || label : placeholder;
  var fieldErrors = form ? form.getFieldsError([props.name]).reduce(function(aggregator, item) {
    return _objectSpread(_objectSpread({}, aggregator), {}, _defineProperty({}, item.name[0], item.errors));
  }, {}) : {};
  var fieldAttributes = _objectSpread(_objectSpread(_objectSpread({}, fieldSettings), placeholderValue ? {
    placeholder: "".concat(intl.formatMessage({
      id: placeholderValue
    })).concat(isRequired && placeholderValue ? " *" : "")
  } : null), {}, {
    rules: rulesList ? translateFormMessages(rulesList, intl.formatMessage) : [],
    initialValue,
    // Start validating on onChange event if field shows an error
    validateTrigger: fieldErrors && fieldErrors[props.name] ? "onChange" : props.validateTrigger
  });
  if (customItemRenderer) {
    return typeof customItemRenderer === "function" ? customItemRenderer(props, {
      fieldSettings,
      formItemProps
    }) : customItemRenderer;
  }
  var inputInitialValue = fieldAttributes.initialValue ? fieldAttributes.initialValue : null;
  if (tag === "select" && fieldAttributes.options && [null, void 0].indexOf(_typeof(fieldAttributes.initialSelectedIndex)) === -1) {
    var selectOptions = fieldAttributes.options(intl);
    var initialOption = selectOptions[fieldAttributes.initialSelectedIndex];
    if (initialOption) {
      inputInitialValue = initialOption.value;
    }
  }
  var formItemAttributes = _objectSpread({
    name: fieldAttributes.name,
    validateTrigger: fieldAttributes.validateTrigger,
    validateFirst: fieldAttributes.validateFirst || false,
    rules: fieldAttributes.rules,
    getValueFromEvent: fieldAttributes.getValueFromEvent
  }, inputInitialValue ? {
    initialValue: inputInitialValue
  } : null);
  if (tag === "customRenderer" && !isFormItem) {
    var name = formItemAttributes.name, attributes = _objectWithoutProperties(formItemAttributes, _excluded2);
    return /* @__PURE__ */ React.createElement(AntDFormItem, _extends({}, formItemProps, attributes), tagToRenderer[tag](props, fieldAttributes, formItemAttributes));
  }
  return /* @__PURE__ */ React.createElement(AntDFormItem, _extends({
    key: fieldSettings.name
  }, formItemProps, formItemAttributes), tag && tagToRenderer[tag] ? tagToRenderer[tag](props, fieldAttributes) : tagToRenderer.input(props, fieldAttributes));
}
__name(FormItemRenderer, "FormItemRenderer");
export {
  FormItemRenderer
};
